<script setup>
import RangeDatepicker from "@/components/global-themed/inputs/RangeDatepicker.vue";
import {useEmailLogs} from "@/composables/email-logs/useEmailLogs";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import {onMounted} from "vue";

const props = defineProps({
  emailAddresses: {
    type: Object,
    default: () => {}
  }
})

const {dateRange, email, queryMeta} = useEmailLogs();

onMounted(() => {
  if (props.emailAddresses.length) {
    email.value = props.emailAddresses[0].value;
  }
})

</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-y-2 tw-w-full">
    <div class="tw-flex tw-justify-between tw-items-center">
      <RangeDatepicker
        :range="dateRange"
        @change="(newRange) => dateRange = newRange"
      />

      <div
        v-if="queryMeta?.total !== undefined"
        class="tw-text-neutral-900 tw-font-bold tw-pt-5 tw-text-base"
      >
        {{ queryMeta.total }} Total Emails
      </div>

      <CustomMultiselect
        id="email-filter"
        v-model="email"
        label="Recipient"
        class="tw-w-120"
        :options="emailAddresses"
        :can-clear="false"
        :can-deselect="false"
        :close-on-select="true"
      />
    </div>

    <small>
      Emails are only retained for up to 90 from the date they were sent
    </small>
  </div>
</template>

